























import {
  defineComponent,
  ref,
  computed,
  toRefs,
  PropType
} from '~/utils/nuxt3-migration'
import { OfferType } from '~/models/classified/types'
import { useI18n } from '~/compositions/i18n'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineComponent({
  props: {
    offertype: {
      type: String as PropType<OfferType>,
      default: ''
    },
    showDeleteOptions: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    const { offertype } = toRefs(props)

    const { t } = useI18n()

    const isForRent = computed(() => offertype.value === 'rent')
    const isWanted = computed(() => offertype.value === 'wanted')
    const isBooking = computed(() => offertype.value === 'booking')

    const actionPerformedStr = computed(() => {
      if (isForRent.value) {
        return t('was_rented')
      } else if (isBooking.value) {
        return t('was_booked')
      } else if (isWanted.value) {
        return t('was_found')
      } else {
        return t('was_sold')
      }
    })

    const actionVerbStr = computed(() => {
      if (isForRent.value) {
        return t('to_rent')
      } else if (isBooking.value) {
        return t('to_book')
      } else {
        return t('to_sell')
      }
    })

    const changedMyMindSuffix = computed(() => {
      if (!isWanted.value) {
        return t('and_dont_want_to', { action: actionVerbStr.value })
      }

      return ''
    })

    const options = [
      {
        text: t('was_handled_through_site', {
          action: actionPerformedStr.value
        }),
        value: 'sold_internal'
      },
      {
        text: t('was_handled_another_way', {
          action: actionPerformedStr.value
        }),
        value: 'sold_external'
      },
      {
        text: t('changed_my_mind', {
          changedMyMindSuffix: changedMyMindSuffix.value
        }),
        value: 'wont_sell'
      },
      {
        text: t('other_reason'),
        value: 'other'
      }
    ]

    const selectedValue = ref<null | string>(null)

    function handleChange(value: string) {
      emit('change', value)
    }

    return { options, selectedValue, handleChange }
  },
  i18n: defineComponentTranslations({
    why_delete_classified: {
      en: 'Why do you want your classified to be deleted?',
      el: 'Για ποιό λόγο θέλεις να γίνει η διαγραφή της αγγελίας σου;'
    },
    choose_a_delete_option: {
      en: 'Select an option below to delete your classified.',
      el: 'Επίλεξε μια επιλογή παρακάτω για να διαγράψεις την αγγελία σου.'
    },
    was_handled_through_site: {
      en: '{action} through Car.gr',
      el: '{action} μέσω Car.gr'
    },
    was_handled_another_way: {
      en: '{action} in another way',
      el: '{action} με άλλο τρόπο'
    },
    changed_my_mind: {
      en: 'I changed my mind {changedMyMindSuffix}',
      el: 'Άλλαξα γνώμη {changedMyMindSuffix}'
    },
    and_dont_want_to: {
      en: "and I don't want to {action}",
      el: 'και δε θέλω να το {action}'
    },
    other_reason: {
      en: 'Other reason',
      el: 'Άλλος λόγος'
    }
  })
})
